import { render, staticRenderFns } from "./referralInfoList.vue?vue&type=template&id=311c7144&scoped=true"
import script from "./referralInfoList.vue?vue&type=script&lang=js"
export * from "./referralInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c7144",
  null
  
)

export default component.exports